import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import messenger from '@/utils/messenger';

var PrintingPage = function (_super) {
  __extends(PrintingPage, _super);

  function PrintingPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.message = undefined;
    return _this;
  }

  PrintingPage.prototype.printing = function () {
    return __awaiter(this, void 0, Promise, function () {
      var timer;

      var _this = this;

      return __generator(this, function (_a) {
        timer = setTimeout(function () {
          _this.$router.push({
            name: 'ResultPage',
            query: {
              state: 'error',
              content: _this.t('打印超时')
            }
          });

          clearTimeout(timer);
        }, 60000);
        return [2];
      });
    });
  };

  PrintingPage.prototype.created = function () {
    this.message = messenger.getInjectData('message');
    var flag = messenger.getInjectData('isPrinting');

    if (!flag) {
      this.$router.push({
        name: 'ResultPage',
        query: {
          state: 'error',
          content: this.t('非法操作')
        }
      });
    } else {
      this.printing();
    }
  };

  PrintingPage = __decorate([Component], PrintingPage);
  return PrintingPage;
}(Vue);

export default PrintingPage;